module.exports = "pegasus/assets/circleline-instagram.png";